import i18n from "../i18n";

const getDetailedTagText = (tag) => {
  // vue selects empty object from dropdown transition
  if (!tag.category) {
    return "";
  }

  let text = `${i18n.t("tags." + tag.category)} | ${tag.name}`;

  if (tag.description) {
    text += ` | ${tag.description}`;
  }

  return text;
};

const getTagDescription = (tag) => {
  return tag.description || tag.name;
};

export { getDetailedTagText, getTagDescription };
